import React, { type ReactNode } from 'react';
import { env } from 'shared/config';

const isProdEnv = env === 'release';

const capitalize = (s: string) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export type PageProps = {
  title: string;
  children?: ReactNode;
};

/** @deprecated Use SEO component instead */
export const Page: React.FC<PageProps> = ({ children, title }) => {
  const formattedTitle = title ? `${capitalize(title)} - Scoopr` : 'Scoopr';

  return (
    <>
      {!isProdEnv ? <meta name="robots" content="noindex" /> : null}
      <title>{formattedTitle}</title>
      {children}
    </>
  );
};

export default Page;
